import { useCallback } from 'react';
import { useHistory } from 'react-router';

export type To = string | { pathname?: string; search?: string; hash?: string };

export type NavigateOptions = { replace?: boolean; state?: unknown };

export interface NavigateFunction {
  (to: To, options?: NavigateOptions): void;
  (delta: number): void;
}

export function useNavigate(): NavigateFunction {
  const history = useHistory();
  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        history.go(to);
      } else if (options?.replace) {
        history.replace(to, options.state);
      } else {
        history.push(to, options?.state);
      }
    },
    [history],
  );
}
